<template>
  <v-container fluid class="pa-6" style="background-color: #f6f8fa; min-height: 100vh;">
    <v-snackbar v-model="showSnackbar" :color="snackbarColor" top right :timeout="3000">
      {{ snackbarText }}
    </v-snackbar>

    <v-card elevation="2" rounded="xl" class="pa-6">
      <v-layout wrap align-center justify-space-between class="mb-6">
        <v-flex xs12 md8>
          <div class="text-h5 font-weight-bold grey--text text--darken-3">
            Manage: <span class="primary--text">Mission and Vision</span>
          </div>
          <div class="grey--text text--darken-1 text-subtitle-2 mt-1">
            Edit the HTML content below for your SARPA application's Mission and Vision.
          </div>
        </v-flex>
        <v-flex xs12 md4 class="text-right">
          <v-btn color="success" large rounded :loading="saving" @click="saveContent" class="px-6 font-weight-bold">
            <v-icon left>mdi-content-save</v-icon> Save Content
          </v-btn>
        </v-flex>
      </v-layout>

      <v-divider class="mb-6"></v-divider>
    <div v-if="loading" class="d-flex justify-center align-center my-12" style="min-height: 200px;">
    <v-progress-circular indeterminate color="primary" size="64" width="5"></v-progress-circular>
    </div>

    <vue-editor v-else v-model="content" placeholder="Write your HTML content here..."></vue-editor>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import { VueEditor } from "vue2-editor";

export default {
  name: "MissionAndVision",
  components: { VueEditor },
  data() {
    return {
      contentType: "mission_and_vision",
      content: "",
      loading: false, 
      saving: false,
      showSnackbar: false,
      snackbarText: "",
      snackbarColor: "success"
    };
  },
  mounted() {
    this.fetchExistingContent();
  },
  methods: {
    fetchExistingContent() {
      this.loading = true; // 1. Start the loader
      axios({
        method: "GET",
        url: `/content/get/${this.contentType}`,
        headers: { "x-auth-token": localStorage.getItem("token") }
      })
      .then((response) => {
        if (response.data.status && response.data.data) {
          const rawData = response.data.data;
          
          if (rawData.content && typeof rawData.content === 'object') {
            this.content = rawData.content.content || "";
          } else {
            this.content = rawData.content || "";
          }
        }
      })
      .catch((err) => {
        console.error(`Failed to load ${this.contentType}:`, err);
        this.showNotification("Failed to load content.", "error");
      })
      .finally(() => {
        this.loading = false; // 2. Turn off the loader (runs on success or error)
      });
    },

    saveContent() {
      this.saving = true;
      axios({
        method: "POST",
        url: "/content/save",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
          "Content-Type": "application/json"
        },
        data: {
          type: this.contentType,
          content: this.content
        }
      })
      .then((response) => {
        if (response.data.status) {
          this.showNotification("Mission and Vision saved successfully!", "success");
        } else {
          this.showNotification(response.data.msg || "Failed to save content", "error");
        }
      })
      .catch((err) => {
        console.error(err);
        this.showNotification("Error saving content.", "error");
      })
      .finally(() => { this.saving = false; });
    },
    showNotification(text, color) {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.showSnackbar = true;
    }
  }
};
</script>
